/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Duplicate_Open_ErrorInputs */

const en_task_duplicate_open_error = /** @type {(inputs: Task_Duplicate_Open_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Another activity of this type is already open.`)
};

const pt_br2_task_duplicate_open_error = /** @type {(inputs: Task_Duplicate_Open_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outra atividade deste tipo já está aberta.`)
};

/**
* | output |
* | --- |
* | "Another activity of this type is already open." |
*
* @param {Task_Duplicate_Open_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_duplicate_open_error = /** @type {((inputs?: Task_Duplicate_Open_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Duplicate_Open_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_duplicate_open_error(inputs)
	return pt_br2_task_duplicate_open_error(inputs)
});